function loadURL(URLValue){
	
	var img = document.createElement('img');
	img.src = URLValue;
	img.style.cssText = 'width:1px;height:1px;border:none;position:absolute;left:-100px;top:-100px;';
	img.onload = function(){
		this.parengNode.removeChild(this);
	}
	
	document.getElementsByTagName('body')[0].appendChild(img);
	
}

// Первый скрипт
/* document.addEventListener('DOMContentLoaded', () => {
    if (window.matchMedia('(max-width: 1420px) and (min-width: 980px)').matches) {
        const menuLeftBox = document.querySelector('.menu_left__box');
        
        if (menuLeftBox) {
            const menuLeftBoxWidth = menuLeftBox.offsetWidth;
            
            document.querySelectorAll('.menu_left__sub').forEach(element => {
                element.style.right = `calc(-100vw + 70px + ${menuLeftBoxWidth}px)`;
            });
            
            document.querySelectorAll('.tit_first').forEach(element => {
                element.style.left = `calc(20px + 70px + ${menuLeftBoxWidth}px)`;
            });
        }
    }
}); */

document.addEventListener('DOMContentLoaded', () => {
  const menuLeftBlockProd = document.querySelector('.menu_left__block');

  // Функция для обновления CSS переменной
  const updateSubMenuWidth = () => {
    // Проверяем, соответствует ли текущая ширина окна медиа-условию
    if (window.innerWidth > 980) {
      const subwidth = menuLeftBlockProd.getBoundingClientRect().width;
      document.documentElement.style.setProperty('--menu_left_sub_w', `${subwidth}px`);
      /* console.log('Ширина обновлена:', subwidth); */ // Для отладки
    }
  };

  // Создаем наблюдатель за изменениями размеров элемента
  const resizeSubObserver = new ResizeObserver(updateSubMenuWidth);
  resizeSubObserver.observe(menuLeftBlockProd);

  // Также отслеживаем изменение размера окна
  window.addEventListener('resize', updateSubMenuWidth);

  // Инициализация при загрузке
  updateSubMenuWidth();
});

// Второй скрипт
document.addEventListener('DOMContentLoaded', () => {
    // View mode icon click
    document.querySelectorAll('.vm_ico').forEach(icon => {
        icon.addEventListener('click', e => {
            document.querySelectorAll('.shop_prod').forEach(prod => {
                prod.classList.remove('viewmode_list');
                prod.classList.add('viewmode_ico');
            });
            
            document.querySelectorAll('.vm_list').forEach(vm => {
                vm.classList.remove('vm_list__on');
            });
            
            document.querySelectorAll('.vm_ico').forEach(vm => {
                vm.classList.add('vm_ico__on');
            });
            
            loadURL('./?viewmode=ico');
            e.preventDefault();
        });
    });

    // View mode list click
    document.querySelectorAll('.vm_list').forEach(list => {
        list.addEventListener('click', e => {
            document.querySelectorAll('.shop_prod').forEach(prod => {
                prod.classList.remove('viewmode_ico');
                prod.classList.add('viewmode_list');
            });
            
            document.querySelectorAll('.vm_ico').forEach(vm => {
                vm.classList.remove('vm_ico__on');
            });
            
            document.querySelectorAll('.vm_list').forEach(vm => {
                vm.classList.add('vm_list__on');
            });
            
            loadURL('./?viewmode=list');
            e.preventDefault();
        });
    });
});

document.addEventListener('DOMContentLoaded', () => {
  const menuLeft = document.querySelector('.menu_left');
  
  if (!menuLeft) {
    console.error('Элемент с классом .menu_left не найден');
    return;
  }

  // Функция для обновления CSS переменной
  const updateMenuWidth = () => {
    // Проверяем, соответствует ли текущая ширина окна медиа-условию
    if (window.innerWidth <= 980) {
      const width = menuLeft.getBoundingClientRect().width;
      document.documentElement.style.setProperty('--menu_left_mob_w', `${width}px`);
      /* console.log('Ширина обновлена:', width); */ // Для отладки
    }
  };

  // Создаем наблюдатель за изменениями размеров элемента
  const resizeObserver = new ResizeObserver(updateMenuWidth);
  resizeObserver.observe(menuLeft);

  // Также отслеживаем изменение размера окна
  window.addEventListener('resize', updateMenuWidth);

  // Инициализация при загрузке
  updateMenuWidth();
});

document.addEventListener('DOMContentLoaded', function() {
    document.getElementById('mob_overlay')?.addEventListener('click', function() {
        document.querySelectorAll(`
            #mob_nav_top:checked ~ .left_menu_and_banner_box input[type="checkbox"]:checked,
            .left_menu_and_banner_box input[type="checkbox"]:checked
        `).forEach(checkbox => checkbox.checked = false);
    });
});


function set_quantity(form_id, atype, afield){
	
	var new_value = 1;
	
	if(!afield){
		var finput = document.getElementById(form_id).getElementsByTagName("input")[0];
	}else{
		var finput = document.getElementById(form_id);
	}
	
	if(atype=="up"){
		new_value = parseInt(finput.value) + 1;
	}else{
		new_value = parseInt(finput.value) - 1;
	}
	
	if(parseInt(new_value)<1){new_value = 1;}
	if(parseInt(new_value)>999){new_value = 999;}
	
	finput.value = new_value;
}